function changeColor() {
  let link = document.getElementById("MegaMenu-Content-1").getElementsByTagName("a");
  let linkMobile = document.getElementById("link-libri").getElementsByTagName("a");
  for(let i = 0; i < link.length; i++){
    let string = new String(link[i].textContent);
    if(string.trim().valueOf() === "Saldi estivi 2023" || string.trim().valueOf() === "Summer sale 2023"){
      link[i].style.color = 'red';
    }
  }
  for(let k = 0; i < linkMobile.length; k++){
    let stringMobile = new String(linkMobile[k].textContent);
    if(stringMobile.trim().valueOf() === "Saldi Estivi 2023" || stringMobile.trim().valueOf() === "Summer sale 2023"){
      linkMobile[k].style.color = 'red';
    }
  }
}
window.addEventListener('load',changeColor());

